export enum OlympicTypes {
  DTM = 'dtm',
  FIXED_SUBJECT = 'fixed_subject',
  FIXED_SUBJECTS = 'fixed_subjects'
}

export enum OlympicStatuses {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  FINISHED = 'finished'
}
